import { Component } from '../../../libs/gin-tonic/helpers/compiler';

import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';
import { SwiperOptions } from '../../../node_modules/swiper/types/swiper-options';

@Component({ className: 'js-swiper' })
export class SwiperComponent {
	constructor(public element: HTMLElement) {
		const sliderType = element.getAttribute('data-slider') ?? '';
		const swiperParams = this.getParamsFromType(sliderType);
		var swiper = new Swiper(element, swiperParams);

		element.querySelectorAll('.js-swiper-jump-second').forEach(el => {
			el.addEventListener('click', () => {
				swiper.slideTo(1);
			});
		});
		element.querySelectorAll('.js-swiper-jump-first').forEach(el => {
			el.addEventListener('click', () => {
				swiper.slideTo(0);
			});
		});
	}

	private getParamsFromType(sliderType: string): SwiperOptions | undefined {
		switch (sliderType) {
			case 'keyVisual':
				return {
					modules: [Pagination],
					loop: true,
					pagination: {
						el: `.swiper-pagination`,
						type: 'bullets',
						clickable: true
					},
					slidesPerView: 1,
					spaceBetween: 0,
					grabCursor: true
				};
			case 'successSlider':
			case 'serviceSlider':
				return {
					modules: [Pagination],
					loop: false,
					pagination: {
						el: `.swiper-pagination`,
						type: 'bullets',
						clickable: true
					},
					slidesPerView: 'auto',
					spaceBetween: 20,
					centeredSlides: true
				};
			case 'pageLinks':
				return {
					modules: [Pagination],
					loop: false,
					pagination: {
						el: `.swiper-pagination`,
						type: 'bullets',
						clickable: true
					},
					slidesPerView: 1,
					spaceBetween: 100,
					breakpoints: {
						992: {
							slidesPerView: 2,
							spaceBetween: 100
						},
						1400: {
							slidesPerView: 3,
							spaceBetween: 80
						}
					}
				};
			case 'sustainability':
				return {
					modules: [Pagination],
					pagination: {
						el: `.swiper-pagination`,
						type: 'bullets',
						clickable: true
					},
					slidesPerView: 1,
					spaceBetween: 0,
					grabCursor: true
				};
		}
	}
}
